<template>
  <div class="text-xs-center">
    <v-dialog
      v-model="dialog"
      width="500"
    >
      <template v-slot:activator="{ on }">
        <v-btn
          :color="color" 
          fab 
          dark 
          small
          v-on="on"
        >
          <v-icon>{{ icon }}</v-icon>
        </v-btn>
      </template>

      <v-card>
        <v-card-title
          class="headline grey lighten-2 py-0"
          primary-title
        >
          Nova Atividade
          <v-spacer></v-spacer>
          <v-tooltip bottom>
            <v-btn
              flat
              fab
              small
              icon
              @click="dialog = false"
              slot="activator"
            >
              <v-icon>close</v-icon>
            </v-btn>
            <span>Cancelar</span>
          </v-tooltip>
          <v-tooltip bottom>
            <v-btn
              color="primary"
              fab
              dark
              small
              @click="adiciona"
              :loading="loading"
              slot="activator"
            >
              <v-icon>done</v-icon>
            </v-btn>
            <span>Salvar</span>
          </v-tooltip>
        </v-card-title>

        <v-card-text>
          <v-text-field 
            v-model="atividade.Descricao" 
            label="Descrição da atividade" 
            prepend-icon="description"
            @keyup.enter="adiciona"
            id="add-desc-atividade"
          ></v-text-field>
          <v-autocomplete
            v-model="atividade.ModeloAtividade"
            :items="modelosAtividadeAtivo"
            item-text="Descricao"
            return-object
            menu-props="auto"
            label="Modelo Atividade"
            hide-details
            prepend-icon="label_important"
            class="mb-3"
            auto-select-first
            no-data-text="Registro não encontrado"
            @change="changeModeloAtividade"
          ></v-autocomplete>
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { mapGetters, mapActions, mapMutations } from 'vuex';
import Atividade from '@/domain/atividade/Atividade';
import AtividadeCliente from '@/domain/atividade/AtividadeCliente';

export default {
  props: {
    icon: {
      type: String,
      default: 'add'
    },
    cliente: {
      default: null
    },
    color: {
      type: String,
      default: 'primary'
    }
  },
  data() {
    return {
      dialog: false,
      loading: false,
      atividade: new Atividade(),
      atividadeCliente: new AtividadeCliente()
    }
  },
  watch: {
    dialog(newValue) {
      if (newValue) return this.$nextTick(() => document.getElementById('add-desc-atividade').focus());
    }
  },
  computed: {
    ...mapGetters(['tiposAtividade', 'modelosAtividadeAtivo'])
  },
  methods: {
    ...mapActions([
      'addAtividade',
      'addAtividadeNode',
      'addClienteNode',
      'fetchTiposAtividade',
      'fetchModelosAtividade',
    ]),
    ...mapMutations(['showNotification', 'closeNotification']),
    changeTipoAtividade(obj) {
      this.atividade.TipoAtividade = obj.Descricao;
      this.atividade.IdTipoAtividade = obj.IdTipoAtividade;
    },
    changeModeloAtividade(obj) {
      this.atividade.ModeloAtividade = obj.Descricao;
      this.atividade.IdModeloAtividade = obj.IdModeloAtividade;
    },
    salvaTipoAtividade() {
      const tipoAtividade = {
        IdTipoAtividade: this.atividade.IdTipoAtividade,
        TipoAtividade: this.atividade.TipoAtividade
      };
      localStorage.setItem('tipoAtividadeCadastro', JSON.stringify(tipoAtividade));
    },
    recuperaTipoAtividade() {
      if (localStorage.getItem('tipoAtividadeCadastro')) {
        const tipoAtividade = JSON.parse(localStorage.getItem('tipoAtividadeCadastro'));
        this.atividade.IdTipoAtividade = tipoAtividade.IdTipoAtividade;
        this.atividade.TipoAtividade = tipoAtividade.TipoAtividade;
      }
    },
    salvaModeloAtividade() {
      const modeloAtividade = {
        IdModeloAtividade: this.atividade.IdModeloAtividade,
        ModeloAtividade: this.atividade.ModeloAtividade
      };
      localStorage.setItem('modeloAtividadeCadastro', JSON.stringify(modeloAtividade));
    },
    recuperaModeloAtividade() {
      if (localStorage.getItem('modeloAtividadeCadastro')) {
        const modeloAtividade = JSON.parse(localStorage.getItem('modeloAtividadeCadastro'));
        this.atividade.IdModeloAtividade = modeloAtividade.IdModeloAtividade;
        this.atividade.ModeloAtividade = modeloAtividade.ModeloAtividade;
      }
    },
    async inicializaBuscas() {
      if (!this.tiposAtividade.length) await this.fetchTiposAtividade();
      if (!this.modelosAtividadeAtivo.length) await this.fetchModelosAtividade();
    },
    async adiciona() {
      if (this.atividade.Descricao) {
        this.loading = true;
        if (this.cliente && this.cliente.Status.startsWith('A')) this.atividade.Observacoes = this.cliente.Observacoes;
        // Guarda o último modelo de atividade selecionado no local storage para seleção automática ao criar atividades
        this.salvaModeloAtividade();
        try {
          // const idAtividade = await this.addAtividade(this.atividade);
          const idAtividade = await this.addAtividadeNode(this.atividade);
          if (this.cliente && this.cliente.Status.startsWith('A')) {
            this.atividadeCliente.IdAtividade = parseInt(idAtividade);
            this.atividadeCliente.Fantasia = this.cliente.Fantasia;
            this.atividadeCliente.IdCliente = this.cliente.IdCliente;
            try {
              await this.addClienteNode(this.atividadeCliente);
            } catch (error) {
              this.showNotification({ text: `Ocorreu um erro ao adicionar o cliente na atividade: ${error}.`, status: 'error' });
            }
          }
          this.loading = false;
          this.dialog = false;
          this.showNotification({ text: `Atividade: ${this.atividade.Descricao} adicionada com sucesso.`, status: 'success' });
          this.$router.push({ name: 'altera atividade', params: { id: idAtividade } });
        } catch (error) {
          this.showNotification({ text: `Ocorreu um erro ao adicionar a atividade: ${error}.`, status: 'error' });
        }
      } else {
        this.loading = false;
        this.showNotification({ text: `Informe a Descrição da atividade.`, status: 'error' });
      }
    }
  },
  async created() {
    await this.inicializaBuscas();
    this.recuperaModeloAtividade();
  }
}
</script>

<style>

</style>
